// extracted by mini-css-extract-plugin
export default {"all_cities":"Cities_all_cities__wbCdt","list":"Cities_list__7xIeE","h3":"Cities_h3__mWFCU"};